<template>
  <div class="vehicleDetail">
    <div class="baseinfo">
      <div class="info-header">
        <div class="avatar">
          <el-image style="width: 75px; height: 50px;" :src="mixinQiniuImg(vehicleInfo.vehiclePhoto)"
            :preview-src-list="[mixinQiniuImg(vehicleInfo.vehiclePhoto)]" alt="车辆图片" />
        </div>
        <div class="basic-info">
          <div class="info-column-item">
            <div class="name">
              <span v-if="vehicleInfo.licenseNo" :style="getPlateStyle(vehicleInfo.licenseNo)">{{ formatPlateNumber(vehicleInfo.licenseNo) }}</span>
              <span v-else>-</span>
            </div>
            <!-- <el-tag 
                  v-for="item in $const.LICENSECOLOR.filter(item => item.value === vehicleInfo.licenseColor)" 
                  :key="item.value" 
                  style="margin: 0 20px;"
                  :style="item.styles">{{ item.label.replace('色', '牌') }}</el-tag> -->
            <el-tag style="margin-left: 10px;" type="danger"
              v-if="$utils.checkValidity(vehicleInfo.compulsoryTrafficInsuranceEnd) < 0">交强险已过期</el-tag>
            <el-tag style="margin-left: 10px;" type="warning"
              v-else-if="$utils.checkValidity(vehicleInfo.compulsoryTrafficInsuranceEnd) < 30">交强险即将过期</el-tag>
            <el-tag style="margin-left: 10px;" type="danger"
              v-if="$utils.checkValidity(vehicleInfo.commercialInsuranceEnd) < 0">商业险已过期</el-tag>
            <el-tag style="margin-left: 10px;" type="warning"
              v-else-if="$utils.checkValidity(vehicleInfo.commercialInsuranceEnd) < 30">商业险即将过期</el-tag>
          </div>
          <div class="info-column-item">
            <span class="label">
              <span style="color: #101626;">编号：</span>
              <span>{{ vehicleInfo.vehicleNo || '-' }}</span>
              <span style="color: #101626; margin-left: 16px;">机构：</span>
              <span>{{ organizationName || '-' }}</span>
              <span style="color: #101626; margin-left: 16px;">当前司机：</span>
              <span>{{ vehicleInfo.driverName || '未绑定' }}</span>
              <template v-if="vehicleInfo.driverPhone">
                <span style="color: #101626; margin-left: 8px;">手机：</span>
                <span>{{ vehicleInfo.driverPhone }}</span>
              </template>
            </span>
            <!-- <el-button type="text" size="medium" @click="vehicleInfoDialogVisible = true">
                <i class="el-icon-edit"></i>
              </el-button> -->
          </div>
          <div class="info-column-item" style="margin-top: 6px;">
            <span>完成订单：<strong>{{ vehicleStat.orderFinishNum || 0 }}</strong></span>
            <span style="margin-left: 20px;">订单流水：<strong class="util-money">¥{{ vehicleStat.orderFee ? Number(vehicleStat.orderFee).toFixed(2) : '0.00' }}</strong></span>
            <span style="margin-left: 20px;">载客人数：<strong>{{ vehicleStat.orderPassengerNum || 0 }}</strong></span>
          </div>
        </div>
      </div>
    </div>

    <el-tabs v-model="activeName">
      <el-tab-pane label="证件信息" name="info">
        <cardinfo v-if="activeName === 'info'" :info="vehicleInfo" @refresh="getvehicleInfo" />
      </el-tab-pane>
      <el-tab-pane label="保单信息" name="policy">
        <policy v-if="activeName === 'policy'" :info="vehicleInfo" @refresh="getvehicleInfo" />
      </el-tab-pane>
      <el-tab-pane label="订单记录" name="orders">
        <vehicleOrders v-if="activeName === 'orders'" :vehicleId="vehicleInfo.id" />
      </el-tab-pane>
      <el-tab-pane label="收入统计" name="income">
        <vehicleIncome v-if="activeName === 'income'" :vehicleId="vehicleInfo.id" />
      </el-tab-pane>
      <el-tab-pane label="监管数据" name="regulatoryData" v-if="btnPreFn('travel_survey_vehicle', false)">
        <regulatoryData v-if="activeName === 'regulatoryData'" :info="vehicleInfo" @refresh="getvehicleInfo" />
      </el-tab-pane>
      <el-tab-pane label="客运监管" name="supervise" v-if="btnPreFn('survey_vehicle', false)">
        <supervise v-if="activeName === 'supervise'" :vehicleId="vehicleInfo.id" />
      </el-tab-pane>
    </el-tabs>
    <vehicleInfoDialog :visible.sync="vehicleInfoDialogVisible" :vehicleInfo="vehicleInfo" :loading="loading"
      @submit="handlevehicleInfoSubmit" />
  </div>
</template>

<script>
import vehicleInfoDialog from "./vehicleInfoDialog.vue";
import cardinfo from './tabs/cardInfo/cardInfo.vue'
import policy from './tabs/policy/policy.vue'
import regulatoryData from './tabs/regulatoryData/regulatoryData.vue'
import supervise from './tabs/supervision/supervision.vue'
import vehicleOrders from './tabs/vehicleOrders/vehicleOrders.vue'
import vehicleIncome from './tabs/vehicleIncome/vehicleIncome.vue'

export default {
  name: "driverDetail",
  components: {
    vehicleInfoDialog,
    cardinfo,
    policy,
    regulatoryData,
    supervise,
    vehicleOrders,
    vehicleIncome
  },
  data() {
    return {
      id: this.$route.query.id,
      organizationName: '',
      activeName: 'info',
      vehicleInfo: {},
      vehicleStat: {},
      vehicleInfoDialogVisible: false,
      loading: false,
      showFullPhone: false,
      showFullIdCard: false
    };
  },
  computed: {},
  created() {
    this.getvehicleInfo();
  },
  methods: {
    async handlevehicleInfoSubmit(formData) {
      this.loading = true
      let url = "/api/v1/manage/vehicle";
      let params = {
        ...this.vehicleInfo,
        ...formData,
        // id: this.id,
        // organizationId: this.vehicleInfo.organizationId,
        // authOrganizationId: this.vehicleInfo.authOrganizationId,
      }
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.vehicleInfoDialogVisible = false
        this.getvehicleInfo()
      }
      this.loading = false
    },
    // 获取车辆详情
    async getvehicleInfo() {
      if (!this.id) {
        return false;
      }

      let url = "/api/v1/manage/vehicle/" + this.id;
      let { code, data } = await this.$axios.get(url);
      if (code === 1) {
        this.vehicleInfo = {
          ...data,
          organizationName: await this.getOrgName(data.organizationId)
        };
        this.organizationName = await this.getOrgName(data.organizationId)
      }
      this.getVehicleStat();
    },
    async getVehicleStat() {
      if (!this.id || !this.vehicleInfo.appKey) return;
      const { code, data } = await this.$axios.get('/api/v1/manage/vehicle/' + this.id + '/income', {
        params: { appKey: this.vehicleInfo.appKey }
      });
      if (code === 1) {
        this.vehicleStat = {
          orderFinishNum: data.orderCount,
          orderFee: data.totalRealFee,
          orderPassengerNum: data.totalPassengerNum
        };
      }
    },
  },
};
</script>

<style lang="less" scoped>
.vehicleDetail {
  padding-top: 100px;

  .baseinfo {
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    position: absolute;
    left: 0;
    top: 0;
    border-bottom: 16px solid #f5f5f5;

    .info-header {
      display: flex;
      align-items: center;
      height: 50px;
      box-sizing: border-box;
      // padding: 20px;

      /deep/ .el-button--medium {
        padding: 0 20px;
      }

      .avatar {
        width: 75px;
        height: 50px;
        flex-shrink: 0;
        text-align: center;
        line-height: 50px;
        overflow: hidden;
      }

      .basic-info {
        height: 100%;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-column-item {
          display: flex;
          align-items: center;
          font-family: SourceHanSansSC, SourceHanSansSC;
          font-size: 14px;
          color: #333333;
          letter-spacing: 1px;
          white-space: nowrap;

          .name {
            font-weight: 500;
            font-size: 18px;
            color: #333333;
          }

          .label {
            color: #000000A6;
          }

        }
      }
    }
  }

  /deep/ .el-tabs__content {
    height: calc(100vh - 310px);
    overflow-y: auto;
    padding-right: 20px;

    &::-webkit-scrollbar {
      width: 5px;
    }

    &>div {
      width: 1196px;
    }
  }
}
</style>